import { render, staticRenderFns } from "./PageNotifications.vue?vue&type=template&id=295396bc"
import script from "./PageNotifications.vue?vue&type=script&lang=js"
export * from "./PageNotifications.vue?vue&type=script&lang=js"
import style0 from "./PageNotifications.vue?vue&type=style&index=0&id=295396bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports